<template>
  <router-link :to="route" class="subscriber-row">
    <div class="cell center">
      {{ bookNumber }}
    </div>
    <div class="cell">
      {{ customerDetail }}
    </div>
    <div class="cell">
      {{ roomTitle }}
    </div>
    <div class="cell">
      {{ bookingDate }}
    </div>
    <div class="cell">
      {{ bookingTimeDuration }}
    </div>
    <div class="cell center">
      {{ numberOfPeople }}
    </div>
    <div :class="status.value" class="cell center badge">
      {{ status.label }}
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    bookNumber: {
      type: null,
      default: undefined,
    },
    customerName: {
      type: null,
      default: undefined,
    },
    customerDetail: {
      type: null,
      default: undefined,
    },
    roomTitle: {
      type: null,
      default: undefined,
    },
    bookingDate: {
      type: null,
      default: undefined,
    },
    bookingTimeDuration: {
      type: null,
      default: undefined,
    },
    numberOfPeople: {
      type: null,
      default: undefined,
    },
    status: {
      type: null,
      default: undefined,
    },
    route: {
      type: null,
      default: undefined,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.subscriber-row {
  display: grid;
  grid-template-columns: 150px 180px 150px 140px 270px 120px 1fr;

  grid-gap: 10px;
  white-space: pre-line;
  content: "\A";
  padding-bottom: 20px;

  border-bottom: $border;

  &:hover {
    background: #fafafa;
    cursor: pointer;
    text-decoration: none;
  }

  > .status {
    text-align: center;
  }

  > .center {
    text-align: center;
  }
}

.cell {
  font-size: 16px;
}

.badge {
  font-size: 0.9rem;
  padding: 4px 10px;
  border-radius: 4px;
  margin: auto;

  &.PENDING {
    background-color: $secondary-color;
  }

  &.CONFRIMED {
    background-color: $warning-color;
  }

  &.DONE {
    background-color: $success-color;
  }

  &.CANCELED {
    background-color: $danger-color;
  }

  &.UNKNOWN {
    background-color: $danger-color;
  }
}
</style>
